
import { SETTINGS, REGISTER } from '@/const/api';
import VRadio from '@/components/ui/VRadio';
import VCheckbox from '@/components/ui/VCheckbox';
import VButton from '@/components/ui/VButton';
import VFormGroup from '@/components/ui/VFormGroup';
import { mixFormValidate } from '@/mixins/validate';
import { required } from 'vuelidate/lib/validators';

const EMAIL_REGEXP = /\S+@\S+\.\S+/;
const PASSWORD_REGEXP = new RegExp('^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.{8,})');

export default {
    name: 'Register',
    mixins: [mixFormValidate],
    components: {
        VRadio,
        VCheckbox,
        VButton,
        VFormGroup
    },
    head: {
        title: 'Регистрация в качестве инвестора или заемщика на платформе Ко-Фи | Ко-Фи'
    },
    async asyncData({ $axios }) {
        const doc = await $axios(SETTINGS);

        return {
            urls: {
                accept1: doc?.data?.named_docs?.platform_rules || ''
            }
        }
    },
    data: () => ({
        form: {
            email: '',
            password: '',
            repeatPassword: '',
            role: '',
            accept1: false,
            accept2: false,
            accept3: false
        },
        urls: {
            accept1: ''
        },
        errors: {},
        loading: false
    }),
    validations: {
        form: {
            role: {
                required
            },
            email: {
                required,
                email: value => EMAIL_REGEXP.test(value)
            },
            password: {
                required,
                password: value => PASSWORD_REGEXP.test(value)
            },
            repeatPassword: {
                required,
                repeatPassword(value) {
                    return value === this.form.password;
                }
            },
            accept1: {
                required: value => value === true
            },
            accept2: {
                required: value => value === true
            }
        }
    },
    computed: {
        labels() {
            const items = {
                accept1: 'Я ознакомлен с правилами Инвестиционной платформы Ко-Фи',
                accept2: `Я согласен <a id="accept-2-link" href="${this.serverImage('person_data_agreement', '/platform/content/document/')}" target="_blank">на обработку персональных данных</a>`,
                accept3: `Я согласен <a id="accept-3-link" href="${this.serverImage('application_18', '/platform/content/document/')}" target="_blank">на получение сообщений рекламного и информационного характера</a>`,
            };
            if (this.urls.accept1) {
                items.accept1 = `Я ознакомлен с <a id="accept-1-link" href="${this.urls.accept1}" target="_blank">правилами Инвестиционной платформы Ко-Фи</a>`;
            }

            return items;
        },
    },
    created() {
        this.role = this.$route.query.role || 'borrower';
    },
    methods: {
        handleSubmit() {
            if (!this.loading) {
                this.touchForm(this.$v.form)
                    .then(() => {
                        this.errors = {};
                        this.loading = true;
                        this.$axios.post(REGISTER, {
                            login: this.form.email,
                            password: this.form.password,
                            type: this.form.role,
                            user_agreement: this.form.accept1,
                            advertising: this.form.accept3,
                            page: this.$route.query.page || ''
                        })
                            .then(() => {
                                window.ym(52250056, 'reachGoal', 'registrationStart')
                                this.$router.push({ name: 'register-email-link', query: { email: this.form.email } });
                            })
                            .catch(({ response }) => {
                                if (response?.data?.error && (response.data.error === 'email_already_in_use' || response.data.error === 'email_already_in_use_in_ipchain')) {
                                    this.$set(this.errors, 'email', response.data.error_message);
                                } else if (response.data && err.data.errors) {
                                    this.$set(this.errors, 'email', response.data.errors.login[0]);
                                    this.$set(this.errors, 'password', response.data.errors.password[0]);
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => null)
            }
        }
    }
}
